import { render, staticRenderFns } from "./blog8.vue?vue&type=template&id=43d8223d"
import script from "./blog8.vue?vue&type=script&lang=js"
export * from "./blog8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports